import {createClient, type ClientConfig} from '@sanity/client'
import {createImageUrlBuilder, type SanityImageSource} from '@sanity/image-url'

export const SANITY_PROJECT_ID = 'o1j1gbq7'
export const SANITY_DATASET = 'production'
export const SANITY_API_VERSION = '2025-01-01'

const baseConfig: ClientConfig = {
  projectId: SANITY_PROJECT_ID,
  dataset: SANITY_DATASET,
  apiVersion: SANITY_API_VERSION,
  useCdn: true,
  perspective: 'published',
}

export const sanityClient = createClient(baseConfig)

const builder = createImageUrlBuilder(sanityClient)

export const urlForImage = (source: SanityImageSource) => builder.image(source)
